import { IDeliveryTimeSlotData } from "@/entities/deliveryTimeSlot";
import { IDeliverySlotRepository } from "@/repositories/deliverySlot";
import { IDeliverySlotService } from ".";

export class DeliverySlotService implements IDeliverySlotService {
    constructor(private repository: IDeliverySlotRepository) {}

    async check(
        branchCode: number,
        dateSlot: string
    ): Promise<IDeliveryTimeSlotData> {
        return this.repository.check(branchCode, dateSlot);
    }

    async book(
        branchCode: number,
        dateSlot: string,
        orderId: string,
        bookingHour: number,
        premium: boolean
    ): Promise<void> {
        return;
    }
    // async getDeliveryCost(
    //     location: ILocation,
    //     apikey: string
    // ): Promise<IPolygonData[]> {
    //     return await this.repository.getDeliveryCost(location, apikey);
    // }
}
